import { render, staticRenderFns } from "./HeadGiftCard.vue?vue&type=template&id=b963164e&scoped=true&"
import script from "./HeadGiftCard.vue?vue&type=script&lang=js&"
export * from "./HeadGiftCard.vue?vue&type=script&lang=js&"
import style0 from "./HeadGiftCard.vue?vue&type=style&index=0&id=b963164e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b963164e",
  null
  
)

export default component.exports